import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  styled,
  StepIconProps,
  Box,
} from "@mui/material";
import Check from "@mui/icons-material/Check";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";

type StepItem = string;

interface CustomStepperProps {
  steps: StepItem[];
  activeStep: number;
  onStepClick: (index: number) => void;
}

const QontoConnector = styled(StepConnector)(({ theme }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const primaryColor =
    reduxTheme.primary_colors?.[400] || theme.palette.primary.main;
  const neutralColor = reduxTheme.neutral_colors?.[800] || "#D6DDEB";

  return {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 9,
      left: "calc(-50% + 15px)",
      right: "calc(50% + 15px)",
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 4,
      border: 0,
      borderRadius: 3,
      backgroundColor: neutralColor,
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
      backgroundColor: primaryColor,
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
      backgroundColor: primaryColor,
    },
  };
});

const QontoStepIconRoot = styled("div")<{
  ownerState: { active?: boolean; completed?: boolean };
}>(({ ownerState }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const primaryColor = reduxTheme.primary_colors?.[400] || "#724E41";
  const neutralColor = reduxTheme.neutral_colors?.[800] || "#D6DDEB";

  return {
    color: neutralColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: 4,
    margin: 1,
    backgroundColor:
      ownerState.active || ownerState.completed ? primaryColor : neutralColor,
    "& .QontoStepIcon-check": {
      color: "#fff",
      fontSize: 16,
      margin: 1,
    },
  };
});

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot
      ownerState={{ active, completed }}
      className={clsx(className)}
    >
      <Check className="QontoStepIcon-check" />
    </QontoStepIconRoot>
  );
}

const CustomStepper: React.FC<CustomStepperProps> = ({
  steps,
  activeStep,
  onStepClick,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
      >
        {steps.map((label, index) => {
          const isActive = index === activeStep;
          return (
            <Step
              key={index}
              onClick={() => onStepClick(index)}
              sx={{ cursor: "pointer" }}
            >
              <StepLabel StepIconComponent={QontoStepIcon}>
                {isActive ? label : null}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default CustomStepper;
